export default __webpack_public_path__ + "static/media/menu2.09c33e5b.svg";